import styled from "@emotion/styled";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  Typography,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import { shouldForwardProp } from "../../common/Common.style";
import ProgressLoader from "../../loader/ProgressLoader";
import theme from "../../theme";

export const SendButton = styled(Button)`
  padding: 8px 30px;
`;

export const MessageItemModalListItemContent = styled(ListItemAvatar)`
  display: flex;
  align-items: center;
  padding: 8px 0;
`;

type RecipientListItemProps = {
  showCheckbox?: boolean;
};

export const MessageItemModalListItem = styled(ListItem, {
  shouldForwardProp: prop =>
    shouldForwardProp<RecipientListItemProps>(["showCheckbox"], prop),
})<RecipientListItemProps>(({ showCheckbox }) => ({
  flexDirection: "column",
  alignItems: "center",
  padding: "0",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "4px",
  transition: "all 0.6s ease",
  width: "100%",
  margin: "5px 0",
  boxShadow: "0 0 1.5px #aeaeae",

  "&:hover": {
    backgroundColor: theme.message?.infoBubble ?? theme.palette.grey[200],
  },
}));

export const MessageItemModalListItemStyle = styled(ListItemButton, {
  shouldForwardProp: prop =>
    shouldForwardProp<RecipientListItemProps>(["showCheckbox"], prop),
})<RecipientListItemProps>(({ showCheckbox }) => ({
  alignItems: "flex-start",
  flexDirection: "column",
  width: "100%",
  cursor: "auto",
  padding: "0 10px",
}));

export const MessageStatusListHeader = styled(Typography)`
  font-weight: 500;
  font-size: 15px;
  margin: 15px 7px;
`;

export const Loader = styled(ProgressLoader)`
  margin-top: 10px;
  height: auto;
`;

export const MessageItemModalContentWrapper = styled(Box)`
  height: calc(100dvh - 250px);
  overflow: auto;
  margin-bottom: 12px;
`;

// flex:1 fills whatever height CommonDialog's fillContentHeight gives it;
// overflow:hidden leaves scrolling solely to the nested ScrollListContainer.
export const ForwardToContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  margin-bottom: 12px;
`;

export const MessagePanelItemWrapper = styled(Box)`
  padding: 24px 10px;
  background: ${theme.message?.messageBackground ??
  theme.palette.background.paper};
  border-radius: 8px;
  margin: 10px 8px;
`;

export const MessageItemModalListWrapper = styled(List)`
  padding: 0 8px;
`;

export const SearchBoxWrapper = styled(Box)`
  padding: 0 7px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-right: 7px;
`;

export const ForwardedInfoBox = styled(Box)`
  margin: 0 8px 8px 8px;
  padding: 5px 10px;
  box-shadow: 0 0 1px #aeaeae;
  border-radius: 4px;
  background: ${theme.message?.messageBackground ??
  theme.palette.background.paper};
  font-size: 14px;
  font-weight: 400;
`;

export const InfoContentWrapper = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
`;

export const InfoContentDetail = styled.span`
  font-weight: 500;
`;

export const ForwardToPanelWrapper = styled(Box)`
  padding: 0 50px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const ForwardToTabItem = styled(Tab)`
  min-height: 0;
  min-width: 70px;
  padding: 0;
`;

export const ForwardToTabsDivider = styled(Divider)`
  margin-bottom: 9px;
`;

export const ForwardToIdleStateWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
  color: ${theme.palette.text.secondary};
`;

export const ForwardToIdleStateSubtext = styled(Typography)`
  margin-top: 4px;
  color: ${theme.palette.text.secondary};
`;

export const CallDrawerContainer = styled(Box)`
  padding: 2px;
  position: relative;
`;

export const CallDrawerHeader = styled(Typography)`
  margin: 10px;
`;
